import { Link, PrefetchBehavior } from "react-router-dom";

// A wrapper around react-router-dom Link that also refreshes the user info from the backend.
// This ensures the latest user layers and widget settings are loaded for when the user returns to the map
export function MapLink(props: { children?: React.ReactNode; to: string; className?: string, role?: string, style?: React.CSSProperties, onClick?: () => void, id?: string, target?: string, tabIndex?: number, prefetch?: PrefetchBehavior }) {
    // const context = useOutletContext<OutletIProps>();

    return <div
    // onClick={() => context.refreshUser()}
    >
        <Link to={props.to}
            className={props.className}
            role={props.role}
            style={props.style}
            onClick={props.onClick}
            id={props.id}
            target={props.target}
            tabIndex={props.tabIndex}
            prefetch={props.prefetch}>
            {props.children}
        </Link></div>
}